<!-- 由 suu 创建于 2021-01-22 星期五 -->
<template>
  <div
    class="body-data-range"
    :style="{ width: barWidth + 'vw' }"
    v-if="rangeInfo"
  >
    <div class="bdr-bg">
      <div
        class="bg-item"
        v-for="(item, index) in rangeInfo.norm_range"
        :key="index"
      >
        <!-- 指针 -->
        <div
          class="item-pointer"
          v-if="index == curPointIndex"
          :style="{ left: leftWidth + 'vw' }"
        ></div>
        <!-- 区间中文 -->
        <div class="item-cent">{{ item }}</div>
        <!-- 区间刻度和值 -->
        <div class="item-data" v-if="index != 0">
          <div class="d-line"></div>
          <div class="d-data">{{ curRange[index] }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'body-data-range',

  components: {},

  props: {
    rangeInfo: {
      type: Object,
      required: true
    },
    barWidth: {
      type: [Number, String],
      default: 78
    }
  },

  data() {
    return {
      // rangeInfoT: {
      //   norm_range: ["偏低", "高"],
      //   range: [10.8],
      //   cur: 16.2,
      //   unit: ''
      // },
      rangeInfoT: null,
      curPointIndex: 0
    }
  },

  computed: {
    // 获取首位刻度 方便对首尾段指针位移
    curRange() {
      let arr = this.rangeInfoT.range || []
      arr.unshift(arr[0] - ((arr[1] || arr[0] * 2) - arr[0]))
      arr.push(
        arr[arr.length - 1] + (arr[arr.length - 1] - (arr[arr.length - 2] || 0))
      )
      return arr
    },
    // 获取当前指针位移
    leftWidth() {
      let left = 0
      let cur = this.rangeInfoT.cur * 1
      if (cur < this.curRange[0]) cur = this.curRange[0]
      if (cur > this.curRange[this.curRange.length - 1])
        cur = this.curRange[this.curRange.length - 1]
      for (let index = 0; index < this.curRange.length; index++) {
        const element = this.curRange[index]
        const element2 = this.curRange[index + 1]
        if (element <= cur && cur <= element2) {
          this.curPointIndex = index
          left =
            ((cur - element) / (element2 - element)) *
              ((this.barWidth * 1) / this.rangeInfoT.norm_range.length) +
            -1.1 // 1.1为根据指针和标线宽度做误差补偿
        }
      }
      return left
    }
  },

  watch: {},

  created() {
    this.rangeInfoT = JSON.parse(JSON.stringify(this.rangeInfo))
  },

  mounted() {},

  destroyed() {},

  methods: {}
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.body-data-range {
  width: 78vw;
  .bdr-bg {
    width: 100%;
    box-sizing: border-box;
    height: 5.3vw;
    border-radius: 4vw;
    background-image: linear-gradient(90deg, #76bfe7 0%, #dc0050 100%);
    display: flex;
    align-items: center;
    justify-content: space-around;
    color: #fff;
    font-size: 2.7vw;
    font-weight: 600;
    .bg-item {
      flex: 1;
      text-align: center;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      .item-pointer {
        width: 0;
        height: 0;
        border-bottom: 0vw solid transparent;
        border-right: 1.35vw solid transparent;
        border-top: 2.9vw solid #dc0050;
        border-left: 1.35vw solid transparent;
        position: absolute;
        top: -5vw;
        left: 0;
      }
      .item-data {
        position: absolute;
        left: -0.15vw;
        display: flex;
        flex-direction: column;
        align-items: center;
        .d-line {
          width: 0.3vw;
          height: 2.7vw;
          background-color: rgba($color: #fff, $alpha: 0.3);
        }
        .d-data {
          white-space: nowrap;
          position: absolute;
          top: 6vw;
          color: #000;
        }
      }
    }
  }
}
</style>
